import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
  const { isAdmin } = useAuth();
  const location = useLocation();

  const handleMenuClick = () => {
    // Close sidebar on mobile when menu item is clicked
    if (window.innerWidth <= 768) {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.remove('active');
      }
    }
  };

  const MenuItem = ({ to, icon, text, isActive }) => (
    <ListGroup.Item 
      as={Link} 
      to={to} 
      action 
      active={isActive}
      className="menu-item"
      onClick={handleMenuClick}
    >
      <div className="menu-icon">
        <i className={`fas fa-${icon}`}></i>
      </div>
      <span className="menu-text">{text}</span>
    </ListGroup.Item>
  );

  return (
    <div className="sidebar">
      <div className="sidebar-menu">
        <MenuItem 
          to="/dashboard"
          icon="tachometer-alt"
          text="Dashboard"
          isActive={location.pathname === '/dashboard'}
        />
        
        {isAdmin && (
          <MenuItem 
            to="/tasks/new"
            icon="plus-circle"
            text="Create Task"
            isActive={location.pathname === '/tasks/new'}
          />
        )}
        
        <MenuItem 
          to="/tasks"
          icon="tasks"
          text="All Tasks"
          isActive={location.pathname === '/tasks'}
        />

        {isAdmin && (
          <MenuItem 
            to="/tasks/trash"
            icon="trash-alt"
            text="Trash"
            isActive={location.pathname === '/tasks/trash'}
          />
        )}
        
        {!isAdmin && (
          <MenuItem 
            to="/my-statistics"
            icon="chart-line"
            text="My Performance"
            isActive={location.pathname === '/my-statistics'}
          />
        )}
        
        {isAdmin && (
          <>
            <div className="sidebar-divider">
              <span>Analytics</span>
            </div>
            
            <MenuItem 
              to="/analytics/departments"
              icon="chart-pie"
              text="Department Analytics"
              isActive={location.pathname.startsWith('/analytics/departments')}
            />
            
            <MenuItem 
              to="/analytics/employees"
              icon="chart-line"
              text="Employee Analytics"
              isActive={location.pathname.startsWith('/analytics/employees')}
            />

            <MenuItem 
              to="/departments"
              icon="building"
              text="Departments"
              isActive={location.pathname === '/departments'}
            />

            <MenuItem 
              to="/employee-details"
              icon="id-card"
              text="Employee Details"
              isActive={location.pathname === '/employee-details'}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
